/// <amd-module name="VSSUI/TooltipEx" />
export { Tooltip } from "./Components/TooltipEx/Tooltip";
export { ITooltipProps } from "./Components/TooltipEx/Tooltip.Props";
